import React, { useState } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

const DragAndDropComponents = ({ components }) => {
    const metaData = JSON.parse(components[0].meta_data)
    const allPageValues = metaData.map(value => value.page);
    const uniquePages = [...new Set(allPageValues)];

    let sortedArray = [], summaryCount = 0
    uniquePages.map(function (pageNo) {
        metaData.map(function (innerValue) {
            components.map(function (innerData) {
                if (innerData.iddashboardConfiguration === innerValue.id && innerValue.page === pageNo) {
                    sortedArray.push(innerData)
                    if (innerData.componentType == 'Summary') {
                        summaryCount = summaryCount + 1
                    }
                }
            })
        })
    })
    const [componentsData, setComponentsData] = useState(sortedArray)

    const handleOnDragEnd = (result) => {
        if (!result.destination) return;
        if (result && result.source.index < summaryCount && result.destination.index >= summaryCount) return;
        if (result && result.source.index >= summaryCount && result.destination.index < summaryCount) return;

        const items = Array.from(componentsData);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);

        setComponentsData(items);
        reArrangedDashboardComponents = items
    }
    return (
        <DragDropContext onDragEnd={handleOnDragEnd}>
            <Droppable droppableId='draganddropcomponents'>
                {(provided) => (
                    <ul className='draganddropcomponents' {...provided.droppableProps} ref={provided.innerRef}>
                        {componentsData.map(({ iddashboardConfiguration, label }, index) => {
                            return metaData.map(({ id, page }, ind) => {
                                if (id === iddashboardConfiguration) {
                                    return (<div>
                                        <Draggable key={iddashboardConfiguration} draggableId={iddashboardConfiguration} index={index}>
                                            {(provided) => (
                                                <div>
                                                    <li ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                                        {label} <p><sub style={{ float: 'right', marginTop: '-1%' }}>Page {page}</sub></p>
                                                    </li>
                                                </div>
                                            )}
                                        </Draggable>
                                    </div>)
                                }
                            })
                        })}
                        {provided.placeholder}
                    </ul>
                )}
            </Droppable>
        </DragDropContext>
    )
}

export default DragAndDropComponents;

